import { useLightboxContext } from "@sphtech/idpf-lightbox-react";

export const useHandleUserAction = () => {
  const { lightbox } = useLightboxContext();

  const handleUserLogin = () => {
    if (!lightbox) return;

    lightbox.initiateLogin();
  };

  const handleUserLogout = (domain?: string) => {
    if (!lightbox) return;

    if (domain) {
      lightbox.initiateLogout(domain);

      return;
    }

    lightbox.initiateLogout();
  };

  const handleUpdatePassword = () => {
    if (!lightbox) return;

    lightbox.initiateUpdatePassword();
  };

  return {
    handleUserLogin,
    handleUserLogout,
    handleUpdatePassword,
  };
};
